import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { Filter, PredefinedFilter } from 'app/area/search-filters/filters/types';
import { SerializePayload } from 'app/area/search-filters/types';

export interface ShouldHideFiltersDrawerPayload {
  queryFilters: CodeComplexValue<string>[];
  predefinedFilters: PredefinedFilter;
  customFilters: Filter[];
}

export interface LoadCodeItems {
  payload?: SerializePayload;
  category?: CodeComplexValue<number>;
  parent?: {
    id: number;
    startIndex: number;
  };
}

export const codeSearchArea = 'code';
